import React, { useState } from 'react';
import {
    IconPenL,
    IconClockS,
    IconCopyL,
    IconThumbUpS,
    IconTrashL,
    UpdateCircleIcon,
} from '../../icons';
import css from './InlineAdminEntity.css';
import { Controls } from '../../components';
import TimeLeft from '../LandingPage/sectionsSuperDeals/SectionSuperDeals/TimeLeft';
import classNames from 'classnames';
import { getTimeDiffRepresentation } from '../../util/time';

export default ({ entity, badges = [], handleAdminAction }) => {
    const { title, endDate, createdAt, inStock, totalLoses = 0, totalWins = 0 } = entity;
    const [controlsPanelOpen, setControlsPanelOpen] = useState(false);

    const { hours, days, minutes } = getTimeDiffRepresentation(new Date(createdAt), new Date());

    const showDate = endDate && endDate.date;
    const upperLine = showDate || inStock;

    const controlOptions = [
        {
            label: 'Bearbeiten',
            icon: <IconPenL />,
            action: () => handleAdminAction('edit', entity),
        },
        {
            label: 'Duplizieren',
            icon: <IconCopyL />,
            action: () => {
                const { totalLoses, totalWins, endDate, ...paramsToInitialize } = entity;
                handleAdminAction('duplicate', paramsToInitialize);
            },
        },
        {
            label: 'Löschen',
            icon: <IconTrashL />,
            action: () => handleAdminAction('remove', entity),
        },
    ];

    return (
        <div className={css.container} id={`flip-card-${entity.id}`}>
            <div className={css.mainContent}>
                <nav>
                    {badges.map(badge => (
                        <div className={css.badge}>{badge}</div>
                    ))}
                </nav>
                <p>{title}</p>
            </div>

            <div className={css.statistics}>
                {upperLine && (
                    <>
                        <div className={css.statisticsRow}>
                            {showDate && <TimeLeft expiredText="Abgelaufen" endDate={endDate} />}
                            {inStock && (
                                <div className={css.statisticsItem}>
                                    <UpdateCircleIcon />
                                    <span>
                                        {inStock - totalWins} / {inStock}
                                    </span>
                                </div>
                            )}
                        </div>
                        <div className={css.delimiter} />
                    </>
                )}

                <div className={css.statisticsRow}>
                    <div className={css.statisticsItem}>
                        <IconThumbUpS />
                        <span>{totalWins} Gewinner</span>
                    </div>
                    <div className={classNames(css.statisticsItem, css.losesStats)}>
                        <IconThumbUpS />
                        <span>{totalLoses} Verlierer</span>
                    </div>
                </div>

                <div className={css.statisticsRow}>
                    <div className={css.statisticsItem}>
                        <IconClockS />
                        <span>
                            {days} {hours} {minutes}
                        </span>
                    </div>
                </div>
            </div>
            <div className={css.controlsHolder}>
                <Controls
                    isOpened={controlsPanelOpen}
                    handleToggle={() => setControlsPanelOpen(prevState => !prevState)}
                    controlHolderProps={{
                        outsideClickHandler: () => setControlsPanelOpen(false),
                    }}
                    menu={<Controls.Menu controlOptions={controlOptions} />}
                >
                    <Controls.Trigger />
                </Controls>
            </div>
        </div>
    );
};
